module.exports = __webpack_public_path__ + "assets/img/96831d59b7b484ed453ed32d7d4e8f2f.svg";